const HintIcon = () => {
    return (
        <i className="fa-solid fa-lightbulb-on"></i>
    )
}

export default HintIcon;